import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const CustomStyledList = styled(List)({
    '& .MuiListItemText-primary': {
        fontWeight: 600,

    },
    '& .MuiListItemIcon-root': {
        fontSize: 25,
        minWidth: '50px'
    },
});

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            width: '100%',
            border: `1px solid ${theme.palette.neutral.light}`, 
            borderRadius: '5px'
        }
    }),
);

export default useStyles;